module.exports = function(totals) {
  // var houseLast = data.house[data.house.length - 1];
  // var senateLast = data.senate[data.senate.length - 1];
  document.querySelector(".positive.senate .number").innerHTML = totals.senatePositive;
  document.querySelector(".quarantined.senate .number").innerHTML = totals.senateQuarantine;
  document.querySelector(".positive.house .number").innerHTML = totals.housePositive;
  document.querySelector(".quarantined.house .number").innerHTML = totals.houseQuarantine;
  // document.querySelector(".released .number").innerHTML = last.Released + last.Recovered;
  // document.querySelector(".recovered .number").innerHTML = last.Recovered;
}